import script from "./jobList.vue?vue&type=script&setup=true&lang=js"
export * from "./jobList.vue?vue&type=script&setup=true&lang=js"

import "./jobList.vue?vue&type=style&index=0&id=4b32b6d4&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b32b6d4"]])

export default __exports__